export default __webpack_public_path__ + "static/media/undertitlescreen.880fae61.png";